import * as React from "react";

export default function RedeemVoucherShowHeaderOwner({row}){

    if (row.owner_verified === 1) return (
        <div>
            <h1 style={{marginBottom: 20}}>Voucher #{row.sn}</h1>
            <h3>{row.owner_first} {row.owner_last}</h3>
            <p>
                {row.owner_formatted_address}, <b>Email:</b> {row.owner_email}, <b>Phone:</b> {row.owner_phone}
            </p>
        </div>
    )

    return (
        <div>
            <h1 style={{marginBottom: 20}}>Voucher #{row.sn}</h1>
            <h3>{row.first} {row.last}</h3>
            <p>
                {row.formatted_address}, <b>Email:</b> {row.email}, <b>Phone:</b> {row.phone}
            </p>
            <p>
                Please check and verify the owner details
            </p>
        </div>
    )
}
